"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var create_roadmap_html_1 = __importDefault(require("./create-roadmap.html"));
var create_roadmap_controller_1 = __importDefault(require("./create-roadmap.controller"));
var roadmap_resolves_1 = require("../roadmap-resolves");
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.admin.roadmaps.create", {
        url: "/create-roadmap",
        controller: "CreateRoadmapController",
        controllerAs: "vm",
        template: create_roadmap_html_1.default,
        resolve: {
            sessionTypes: roadmap_resolves_1.getSessionTypes,
            instructors: roadmap_resolves_1.getInstructors,
            reportcardTypes: roadmap_resolves_1.getReportcardTypes,
            documentTemplates: roadmap_resolves_1.getDocumentTemplates,
            tasks: roadmap_resolves_1.getSchoolTasks,
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("drivecoach.admin.roadmaps.create", [])
    .config(config)
    .controller("CreateRoadmapController", create_roadmap_controller_1.default);
